export var DocumentUploadingStatus;
(function (DocumentUploadingStatus) {
    DocumentUploadingStatus[DocumentUploadingStatus["Uninitialized"] = 0] = "Uninitialized";
    DocumentUploadingStatus[DocumentUploadingStatus["Uploading"] = 1] = "Uploading";
    DocumentUploadingStatus[DocumentUploadingStatus["Uploaded"] = 2] = "Uploaded";
    DocumentUploadingStatus[DocumentUploadingStatus["Error"] = 3] = "Error";
})(DocumentUploadingStatus || (DocumentUploadingStatus = {}));
